export default "__VITE_ASSET__D9SBB27O__"